import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import { DeviceCart } from '@kion/data-models';

export const loadAllSuccess = createActionWithCorrelation(
  "[DeviceCart] loadAll Success",
  props<{ deviceCarts: DeviceCart[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[DeviceCart] loadAll Error",
  props<{error: any}>()
);
export const loadAll = createActionWithCorrelation(
  "[DeviceCart] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);

export const loadCartByDeviceSuccess = createActionWithCorrelation(
  "[DeviceCart] load cart by device success",
  props<{ deviceCart: DeviceCart }>()
);
export const loadCartByDeviceError = createActionWithCorrelation(
  "[DeviceCart] load cart by device error",
  props<{ error: any }>()
);
export const loadCartByDevice = createActionWithCorrelation(
  "[DeviceCart] load cart by device",
  props<{ factory: string, deviceId: string }>(),
  loadCartByDeviceSuccess.type,
  loadCartByDeviceError.type
);

export const addToCartSuccess = createActionWithCorrelation(
  "[DeviceCart] add to cart success",
  props<{ deviceCart: DeviceCart }>()
);
export const addToCartError = createActionWithCorrelation(
  "[DeviceCart] add to cart error",
  props<{ error: any }>()
);
export const addToCart = createActionWithCorrelation(
  "[DeviceCart] add to cart",
  props<{ factory: string, deviceId: string, id: string, featureId: string, salesRule: string }>(),
  addToCartSuccess.type,
  addToCartError.type
);

export const saveCartSuccess = createActionWithCorrelation(
  "[DeviceCart] save cart success",
  props<{ deviceCart: DeviceCart }>()
);
export const saveCartError = createActionWithCorrelation(
  "[DeviceCart] save cart error",
  props<{ error: any }>()
);
export const saveCart = createActionWithCorrelation(
  "[DeviceCart] save cart",
  props<{ factory: string, deviceId: string, id: string }>(),
  saveCartSuccess.type,
  saveCartError.type
);

export const placeOrderSuccess = createActionWithCorrelation(
  "[DeviceCart] place order success",
  props<{ orderNumber: string, deviceCartId: string }>()
);
export const placeOrderError = createActionWithCorrelation(
  "[DeviceCart] place order error",
  props<{ error: any }>()
);
export const placeOrder = createActionWithCorrelation(
  "[DeviceCart] place order",
  props<{ cartId: string }>(),
  placeOrderSuccess.type,
  placeOrderError.type
);

export const removeFromCartSuccess = createActionWithCorrelation(
  "[DeviceCart] remove from cart success",
  props<{ deviceCart: DeviceCart }>()
);
export const removeFromCartError = createActionWithCorrelation(
  "[DeviceCart] remove from cart error",
  props<{ error: any }>()
);
export const removeFromCart = createActionWithCorrelation(
  "[DeviceCart] remove from cart",
  props<{ factory: string, deviceId: string, cartId: string, entry: number }>(),
  removeFromCartSuccess.type,
  removeFromCartError.type
);

export const clearStore = createActionWithCorrelation(
  "[DeviceCart] clear store"
);

export const updateCartSuccess = createActionWithCorrelation(
  "[DeviceCart] update cart success",
  props<{ deviceCart: DeviceCart }>()
);
export const updateCartError = createActionWithCorrelation(
  "[DeviceCart] update cart error",
  props<{ error: any }>()
);
export const updateCart = createActionWithCorrelation(
  "[DeviceCart] update cart",
  props<{ factory: string, quoteId: string, cartId: string, status: string, note: string, poNumber: string,
     ccRecipients: string[], poDate: string, deviceId: string }>(),
  updateCartSuccess.type,
  updateCartError.type
);

export const deleteCartSuccess = createActionWithCorrelation(
  "[DeviceCart] delete cart success",
  props<{ cartId: string }>()
);
export const deleteCartError = createActionWithCorrelation(
  "[DeviceCart] delete cart error",
  props<{error: any}>()
);
export const deleteCart = createActionWithCorrelation(
  "[DeviceCart] delete Cart",
  props<{ factory: string, deviceId: string, cartId: string }>(),
  deleteCartSuccess.type,
  deleteCartError.type
);
